import classNames from 'classnames'
import CalculatorComplete from 'components/Organisms/CalculatorComplete'

export default function Calculator() {
  const bodyClassname = classNames(
    'container',
    'mx-auto',
    'mt-24',
    'space-y-4',
    'text-center',
    'md:text-left',
    'md:space-y-10',
    'max-w-screen-xl',
    'md:px-28',
    'relative',
    'z-10',
  )
  return (
    <div className={bodyClassname}>
      <CalculatorComplete />
    </div>
  )
}
